import React, { useEffect, useState } from 'react';
import styles from './FAQCard.module.css';
import { useTranslation } from 'react-i18next';
import { Accordion, Row, Col } from 'react-bootstrap';


type FAQCardProps = {};

type FAQItemData = {
  label: string,
  custom?: (label: string) => JSX.Element
}

export const FAQCard: React.FC<FAQCardProps> = React.memo(() => {
  const { t } = useTranslation();
  const faqLabels: FAQItemData[] = [
    {
      label: 'browser-version',
    },
    {
      label: 'user-property-limit',
    },
    {
      label: 'pair-how-to',
    },
    {
      label: 'user-invitation-expiry',
    },
    {
      label: 'att-service',
      custom: (label: string) =>
        <span className={styles.answer}>
          {t(`faq-${label}-answer`)}<a rel={'noreferrer noopener'} href={t(`faq-${label}-link`)}>{'AT&T Wireless Coverage Map'}</a>{'.'}
        </span>
    },
    {
      label: 'firewall-ports',
      custom: (label: string) =>
        <>
          <span className={styles.answer}>
            {t(`faq-${label}-answer`)}
          </span>
          <ul>
          {[`faq-${label}-answer-dns-port`, `faq-${label}-answer-http-port`, `faq-${label}-answer-https-port`, `faq-${label}-answer-mqtt-port`, `faq-${label}-answer-remote-access-port`]
            .map((faqAnswerTranslationLabel, index) => {
              return <li key={`${label}-${faqAnswerTranslationLabel}-${index}`}>{t(faqAnswerTranslationLabel)}</li>
            })}
        </ul>
      </>
    }
  ];

  const [clickedLabel, setClickedLabel] = useState('');
  useEffect(() => {
    clickedLabel &&
    window.analytics.track("Viewed FAQ Item", {
      FAQ: clickedLabel,
    });
  }, [clickedLabel]);
  return (
    <div className={styles.root}>
      <Accordion as={Col} onSelect={(eventKey: any) => faqLabels[eventKey] !== undefined && setClickedLabel(faqLabels[eventKey].label)}>
      {
        faqLabels.map((item, index) =>
         <>
            <Accordion.Toggle eventKey={index.toString()} as={Row}>
              <span className={styles.faqQuestion}>{t(`faq-${item.label}-question`)}</span>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={index.toString()}>
              <div className={styles.faqAnswer}>
                {
                  item.custom ? item.custom(item.label) : <span className={styles.answer}>{t(`faq-${item.label}-answer`)}</span>
                }
              </div>
            </Accordion.Collapse>
          { index !== faqLabels.length - 1 ? <hr /> : null }
         </>
        )
      }
      </Accordion>
    </div>
  )
});
